import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchSupport(userplan = null) {
  const [support, setSupport] = useState();
  const [loading, setLoading] = useState(true);

  const fetchSupport = async () => {
    setLoading(true);
    try {
      const { data } = await http.get("dashboard/get_support_details/", {
        params: { flow: "company", userplan_id: userplan },
      });
      setSupport(data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSupport();
  }, []);

  return {
    support,
    tpaName: support?.claims_details?.tpa_name,
    loading,
  };
}

export default useFetchSupport;
